import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { DateTimePicker } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import {
    Alert, Autocomplete, Box,
    CardHeader,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Skeleton,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableRow,
    Tabs,
    TextField,
    Typography
} from "@mui/material";
import Button from "@mui/material/Button";
import { withStyles } from "@mui/styles";
import axios from "axios";
import moment from "moment";
import * as React from "react";
import ReactCountryFlag from "react-country-flag";
import { NavLink } from "react-router-dom";
import { Avatar } from "../../components/Avatar";
import { CoatOfArms } from "../../components/CoatOfArms";
import { Config } from "../../config/config";
import { CountryCodes } from "../../utils/countryCodes";
import { getGlobalVar, Helpers } from "../../utils/helpers";
import { PopupMessage } from "../../utils/message";
import { GET_ITEM_NAME_BY_ID } from "../ItemEditor/item";
import { DefaultProps } from "../LayoutWrapper";
import { EditPlayerAvatar } from "./EditAvatar";
import { EditUsername } from "./EditUsername";
import { ExportPlayer } from "./exportPlayer";
import { MessagePlayer } from "./messagePlayer";
import { PlayerMessages } from "./messages";
import { PlayerAchievementsGroup } from "./playerAchievementsGroup";
import { PlayerActivities } from "./playerActivities";
import { PlayerAnalytics } from "./playerAnalytics";
import { PlayerArmy } from "./playerArmy";
import { PlayerBuildings } from "./playerBuildings";
import { PlayerChatHistory } from "./playerChatHistory";
import { PlayerInventory } from "./playerInventory";
import { PlayerLatestActivity } from "./playerLatestActivity";
import { PlayerLatestSessions } from "./playerLatestSessions";
import { PlayerProcesses } from "./playerProcesses";
import { PlayerPurchases } from "./playerPurchaces";
import { PlayerWeapons } from "./playerWeapons";
import { PunishmentHistory } from "./PunishmentHistory";
import { TransferPlayer } from "./transferPlayer";
import {PlayerBattleLogs} from "./playerBattleLogs";
import {PlayerRubyLogs} from "./playerRubyLog";
import {PlayerRubyWager} from "./playerRubyWagerBattleReport";
import {PlayerMail} from "./playerMail";
import {PlayerSession} from "./playerSession";
import {PlayerBoobyTraps} from "./playerBoobyTraps";
import {PlayerUpdateRuby} from "./playerUpdateRuby";

export const TabPanel = (props: any) => {
    const {children, value, index, ...other} = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`nav-tabpanel-${index}`}
            aria-labelledby={`nav-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </Typography>
    );
};

const formButtonStyle = {
    display: "inline-block",
    fontSize: 20,
    marginLeft: 5,
};

const successButtonStyle = {
    ...formButtonStyle,
    color: "green",
};

const cancelButtonStyle = {
    ...formButtonStyle,
};

interface PlayersState {
    playerId: string;
    tempValues: any;
    playerData: any;
    playersEnviroment: any;
    parsedEnviroment: any;
    itemsConfig: any[];
    dataLoaded: boolean;
    activeFileContent: LogFileContent | null;
    avatars: any;
    leagues: any;
    heroesConfig: any[];
    originalGold: number;
    originalPower: number;
    originalRank: number;
    originalVip: number;

    banModalVisible: boolean;
    muteModalVisible: boolean;
    unbanModalVisible: boolean;
    unmuteModalVisible: boolean;
    removeProfilePictureModalVisible: boolean;
    notificationModalVisible: boolean;
    rechargeModalVisible: boolean;
    lastLoginModalVisible: boolean;
    shieldModalVisible: boolean;
    notificationTitle: string;
    notificationDescription: string;
    noNotificationTitle: boolean;
    noNotificationDescription: boolean;
    exportInProgress: boolean;
    activeTab: string;
    lastLoginValue: string;
    shieldExpireValue: string;
    banForm: {
        expiresAt: Date;
        type: number;
        reason: string;
    };
    muteForm: {
        expiresAt: Date;
        type: number;
        reason: string;
    };

    rechargeGems: number;
    updateGoldValue: number;
    updateOilValue: number;
}

interface LogFileContent {
    username: string;
    device_id: string;
    session_start: string;
    session_end: string;
    actions: LogFileContentAction[];
}

interface UpdateProps {
    type: string;
    value: string;
    inputType: string;
    parameters: string;
    object: string;
    items?: any
}

interface LogFileContentAction {
    time: string;
    method: string;
    incoming_data: Incomingdata;
    response: Incomingdata;
    crystal: string;
    honey: string;
    rubies: number;
    error: boolean;
    units: string[];
    queue_units: string[];
    environment: any;
}

interface Incomingdata {
    [key: string]: any;
}

class PlayerWrapped extends React.Component<DefaultProps, PlayersState> {
    constructor(props) {
        super(props);
        // List with grid items
        this.state = {
            playerId: props.match.params.playerId,
            playerData: {},
            playersEnviroment: [],
            parsedEnviroment: null,
            dataLoaded: false,
            itemsConfig: [],
            avatars: {},
            leagues: {},
            heroesConfig: [],

            activeFileContent: null,
            originalGold: 0,
            originalPower: 0,
            originalRank: 0,
            originalVip: 0,

            banModalVisible: false,
            muteModalVisible: false,
            unbanModalVisible: false,
            unmuteModalVisible: false,
            notificationModalVisible: false,
            rechargeModalVisible: false,
            lastLoginModalVisible: false,
            shieldModalVisible: false,
            removeProfilePictureModalVisible: false,

            notificationTitle: "",
            notificationDescription: "",
            lastLoginValue: "",
            shieldExpireValue: "",
            noNotificationTitle: false,
            noNotificationDescription: false,
            exportInProgress: false,
            activeTab: this.props.match.params.activeTab || "general",

            rechargeGems: 0,

            banForm: {
                type: 1,
                expiresAt: new Date(),
                reason: "",
            },

            muteForm: {
                type: 1,
                expiresAt: new Date(),
                reason: "",
            },
            tempValues: {},
            updateGoldValue: 0,
            updateOilValue: 0,
        };

        document.title = Helpers.documentTitle("Player");
    }

    componentDidMount() {
        this.fetchConfigData();
    }

    fetchItemsConfig = () => axios.get(`${Config.getInstance.apiUrl}/api/buildings/config`, {
        headers: {
            Authorization: Helpers.getSessionId(),
            env: this.props.activeEnv,
        },
    });

    fetchUserData = () => axios.get(`${Config.getInstance.apiUrl}/api/user/${this.state.playerId}`, {
        headers: {Authorization: Helpers.getSessionId(), env: this.props.activeEnv},
    });

    fetchUserEnviroment = () => axios.get(`${Config.getInstance.apiUrl}/api/user/${this.state.playerId}/enviroment`, {
        headers: {Authorization: Helpers.getSessionId(), env: this.props.activeEnv},
    });

    fetchHeroes = () =>
        axios.get(`${Config.getInstance.apiUrl}/api/units`, {
            headers: {
                Authorization: Helpers.getSessionId(),
                env: this.props.activeEnv,
            },
        });

    fetchLeagues = () => axios.get(`${Config.getInstance.apiUrl}/api/leagues/fetch`, {
        headers: {
            Authorization: Helpers.getSessionId(),
            env: this.props.activeEnv
        },
    });

    fetchParseEnvironment = () => axios.get(`${Config.getInstance.apiUrl}/api/user/${this.state.playerId}/parse_enviroment`, {
        headers: {
            Authorization: Helpers.getSessionId(),
            env: this.props.activeEnv,
        },
    });

    fetchConfigData = () =>
        axios.all([
            this.fetchUserData(),
            this.fetchUserEnviroment(),
            this.fetchLeagues(),
            this.fetchHeroes(),
            this.fetchItemsConfig(),
            this.fetchParseEnvironment(),
        ]).then(axios.spread((
            userData,
            userEnviroment,
            leagues,
            heroesConfig,
            itemsConfig,
            parsedEnviroment
        ) => {
            if (typeof userData.data.data?.fcm === "string") {
                userData.data.data.fcm = JSON.parse(userData.data.data.fcm);
            }

            console.log(`quitest playerData`, userData.data.data);

            this.setState({
                dataLoaded: true,
                playerData: userData.data.data,
                playersEnviroment: userEnviroment.data.data,
                leagues: leagues.data.data,
                heroesConfig: heroesConfig.data.data.heroes,
                itemsConfig: itemsConfig.data.data,
                originalGold: userData.data.data.rubies,
                originalPower: userData.data.data.current_power,
                originalVip: userData.data.data.vip_system.points,
                originalRank: userData.data.data.rank || 0,
                parsedEnviroment: parsedEnviroment.data,
            });

            document.title = Helpers.documentTitle(userData.data.data.name);
        })).catch(error => {
            PopupMessage.error("Something went wrong", 5, error);
        });

    resetRank() {
        const tempPlayerData = {...this.state.playerData};
        const leagues = getGlobalVar("LEAGUES");
        const leagueDivision = leagues.find(item => item.min <= this.state.originalRank && item.max >= this.state.originalRank);

        tempPlayerData.rank = this.state.originalRank;
        tempPlayerData.current_league = leagueDivision.key;

        this.setState({playerData: tempPlayerData});
    }

    saveRank() {
        axios.put(`${Config.getInstance.apiUrl}/api/user/${this.state.playerId}/rank`, {
            rank: this.state.playerData.rank,
            best_rank: this.state.playerData.best_rank,
            league: this.state.playerData.league,
            best_league: this.state.playerData.best_league
        }, {
            headers: {
                Authorization: Helpers.getSessionId(),
                env: this.props.activeEnv,
            },
        })
            .then(data => {
                this.setState({
                    originalRank: this.state.playerData.rank,
                });
            })
            .catch(() => {
                PopupMessage.error("Something went wrong!");
            });
    }

    changeRank(e) {
        const tempPlayerData = {...this.state.playerData};
        const leagues = getGlobalVar("LEAGUES");
        const maxRank = leagues[leagues.length - 1].max;

        let rank = +e.target.value;

        if (rank > maxRank) {
            rank = maxRank;
        }

        const leagueDivision = leagues.find(item => item.min <= rank && item.max >= rank);

        tempPlayerData.rank = rank;
        tempPlayerData.league = leagueDivision.key;

        if (tempPlayerData.rank > tempPlayerData.best_rank) {
            tempPlayerData.best_rank = rank;
            tempPlayerData.best_league = leagueDivision.key;
        }

        this.setState({playerData: tempPlayerData});
    };

    onChangeUpdateValue(e, property) {
        const value = e.target.value;
        
        if (property === "updateGoldValue") {
            this.setState({updateGoldValue: value});
        } else if (property === "updateOilValue") {
            this.setState({updateOilValue: value});
        }
    }

    onUpdateResource = async (resource: string) => {
        const value = resource === "updateGoldValue" ? this.state.updateGoldValue : this.state.updateOilValue;
        
        // Check is Nan
        if (isNaN(value)) {
            PopupMessage.error("Value must be a number");
            return;
        }

        const url = `${Config.getInstance.apiUrl}/api/user/${this.state.playerId}/resources`;
        const data = {
            type: resource === "updateGoldValue" ? "gold" : "oil",
            value
        };

        await axios.put(url, data, {
            headers: {
                Authorization: Helpers.getSessionId(),
                env: this.props.activeEnv,
            },
        });
        
        PopupMessage.success("Resource updated");

        // Reset the value
        this.setState({updateGoldValue: 0, updateOilValue: 0});

        // Fetch the user data again
        this.fetchConfigData();
    }

    onTabChange = (_event, tab: string) => {
        this.setState({activeTab: tab}, () => {
            Helpers.pushURL(`players/${this.state.playerId}/${tab}`);
        });
    };

    canBan() {
        if (!this.state.playerData.ban_type) {
            return true;
        }

        return this.state.playerData.ban_type === 0;
    }

    canMute = () => {
        if (!this.state.playerData.muted) {
            return true;
        }

        return this.state.playerData.muted.type === 0;
    };

    toggleRemoveProfilePictureModal = (state: boolean) => {
        this.setState({
            removeProfilePictureModalVisible: state,
        });
    };

    showBanModal = () => {
        this.setState({
            banModalVisible: true,
        });
    };
    showUnbanModal = () => {
        this.setState({
            unbanModalVisible: true,
        });
    };
    showMuteModal = () => {
        this.setState({
            muteModalVisible: true,
        });
    };
    showUnmuteModal = () => {
        this.setState({
            unmuteModalVisible: true,
        });
    };

    showNotificationModal = () => {
        this.setState({
            notificationModalVisible: true,
        });
    };

    hideNotificationModal = () => {
        this.setState({
            notificationModalVisible: false,
        });
    }

    showLastLoginModal = () => {
        this.setState({
            lastLoginModalVisible: true,
            lastLoginValue: new Date(this.state.playerData.last_login).toISOString(),
        });
    }

    showRechargeModal = () => {
        this.setState({
            rechargeModalVisible: true,
        });
    }

    showShieldModal = () => {
        this.setState({
            shieldModalVisible: true,
            shieldExpireValue: new Date(this.state.playerData.shield_expire_date).toISOString(),
        });
    }

    hideLastLoginModal = () => {
        this.setState({
            shieldModalVisible: false,
        });
    }

    hideShieldModal = () => {
        this.setState({
            shieldModalVisible: false,
        });
    };

    hideBanModal = () => {
        this.setState({
            banModalVisible: false,
        });
    };
    hideUnbanModal = () => {
        this.setState({
            unbanModalVisible: false,
        });
    };
    hideMuteModal = () => {
        this.setState({
            muteModalVisible: false,
        });
    };
    hideUnmuteModal = () => {
        this.setState({
            unmuteModalVisible: false,
        });
    };
    removeProfilePicture = () => {
        axios.put(`${Config.getInstance.apiUrl}/api/user/${this.state.playerId}/removeProfilePicture`, {},
            {
                headers: {
                    Authorization: Helpers.getSessionId(),
                    env: this.props.activeEnv,
                },
            })
            .then(data => {
                const tempPlayerData = {...this.state.playerData};
                tempPlayerData.avatar = 21007;
                this.toggleRemoveProfilePictureModal(false);

                return this.setState({
                    playerData: tempPlayerData,
                });
            })
            .catch(() => {
                PopupMessage.error("Something went wrong!");
            });
    };
    unbanPlayer = () => {
        axios.put(`${Config.getInstance.apiUrl}/api/user/${this.state.playerId}/unban`, {},
            {
                headers: {
                    Authorization: Helpers.getSessionId(),
                    env: this.props.activeEnv,
                },
            })
            .then(data => {
                const tempPlayerData = {...this.state.playerData};
                tempPlayerData.ban_type = 0;
                this.hideUnbanModal();

                return this.setState({
                    playerData: tempPlayerData,
                });
            })
            .catch(() => {
                PopupMessage.error("Something went wrong!");
            });
    };
    banPlayer = () => {
        axios.put(`${Config.getInstance.apiUrl}/api/user/${this.state.playerId}/ban`, {
                type: this.state.banForm.type,
                reason: this.state.banForm.reason,
                expiresAt: this.state.banForm.expiresAt.getTime(),
            },
            {
                headers: {
                    Authorization: Helpers.getSessionId(),
                    env: this.props.activeEnv,
                },
            })
            .then(_ => {
                const tempPlayerData = {...this.state.playerData};
                tempPlayerData.ban_type = this.state.banForm.type;
                tempPlayerData.ban_reason = this.state.banForm.reason;
                tempPlayerData.ban_expires_at = this.state.banForm.expiresAt;

                this.hideBanModal();

                return this.setState({
                    playerData: tempPlayerData,
                });
            })
            .catch(() => {
                PopupMessage.error("Something went wrong!");
            });
    };
    mutePlayer = () => {
        axios.put(`${Config.getInstance.apiUrl}/api/user/${this.state.playerId}/mute`, {
                type: this.state.muteForm.type,
                reason: this.state.muteForm.reason,
                expiresAt: this.state.muteForm.expiresAt.getTime(),
            },
            {
                headers: {
                    Authorization: Helpers.getSessionId(),
                    env: this.props.activeEnv,
                },
            })
            .then(data => {
                const tempPlayerData = {...this.state.playerData};
                tempPlayerData.muted = {
                    type: this.state.muteForm.type,
                    reason: this.state.muteForm.reason,
                    expiresAt: this.state.muteForm.expiresAt,
                };
                this.hideMuteModal();

                return this.setState({
                    playerData: tempPlayerData,
                });

                PopupMessage.error("Something went wrong!");
            })
            .catch(error => {
                PopupMessage.error("Something went wrong!", 5, error);
            });
    };
    unmutePlayer = () => {
        axios.put(`${Config.getInstance.apiUrl}/api/user/${this.state.playerId}/unmute`, {},
            {
                headers: {
                    Authorization: Helpers.getSessionId(),
                    env: this.props.activeEnv,
                },
            })
            .then(data => {
                const tempPlayerData = {...this.state.playerData};
                tempPlayerData.muted.type = 0;
                this.hideUnmuteModal();

                return this.setState({
                    playerData: tempPlayerData,
                });

                PopupMessage.error("Something went wrong!");
            })
            .catch(error => {
                PopupMessage.error("Something went wrong!", 5, error);
            });
    };

    banFormChange = (e, k, forceInt = false) => {
        this.setState((state) => {
            state.banForm[k] = forceInt ? parseInt(e.target.value, 10) : e.target.value;

            return state;
        });
    };

    banFormDateChange = (date) => {
        this.setState(state => {
            state.banForm.expiresAt = date;

            return state;
        });
    };

    muteFormChange = (e, k, forceInt = false) => {
        this.setState((state) => {
            state.muteForm[k] = forceInt ? parseInt(e.target.value, 10) : e.target.value;

            return state;
        });
    };

    muteFormDateChange = (date) => {
        this.setState(state => {
            state.muteForm.expiresAt = date;

            return state;
        });
    };

    changeNotificationTitle = (e: any) => {
        const title = e.target.value;
        this.setState({
            notificationTitle: title,
        });
    };
    changeNotificationDescription = (e: any) => {
        let text = e.target.value;
        text = text.replace(/(\r\n|\n|\r)/gm, "\n");
        this.setState({
            notificationDescription: text,
        });

    };

    notificationModal() {
        if (!this.state.dataLoaded) {
            return <Skeleton width={110} height={55}/>
        }

        return <React.Fragment>
            <Button
                disableElevation
                onClick={this.showNotificationModal}
                variant="contained"
                disabled={!this.state.playerData?.fcm?.length || this.state.playerData?.is_online}
                size="small"
            >
                Send Notification
            </Button>
            <Dialog
                open={this.state.notificationModalVisible}
                onClose={this.hideNotificationModal}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle id="draggable-dialog-title">
                    Send Notification to Player
                </DialogTitle>
                <DialogContent dividers>
                    <FormControl required fullWidth>
                        <TextField
                            required
                            error={this.state.noNotificationTitle}
                            id="reward-title"
                            label="Title"
                            value={this.state.notificationTitle}
                            onChange={this.changeNotificationTitle}
                            type="text"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            margin="normal"
                        />
                    </FormControl>
                    <FormControl fullWidth required>
                        <TextField
                            required
                            error={this.state.noNotificationDescription}
                            id="reward-text"
                            label="Text"
                            value={this.state.notificationDescription}
                            onChange={this.changeNotificationDescription}
                            type="text"
                            multiline
                            rows="10"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            margin="normal"
                        />
                    </FormControl>
                </DialogContent>

                <DialogActions>
                    <Button disableElevation onClick={this.cancel} color="primary" variant="contained">
                        Cancel
                    </Button>
                    <Button disableElevation onClick={this.sendNotification} color="primary" variant="contained">
                        Send
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    }

    changeLastLoginValue = (date) => {
        this.setState({
            lastLoginValue: date,
        });
    };

    changeShieldExpire = (date) => {
        this.setState({
            shieldExpireValue: date,
        });
    };

    shieldModal() {
        return <React.Fragment>
            <a href="javascript:;" onClick={this.showShieldModal}>
                {this.state.playerData?.shield_expire_date ? Helpers.formatDateWithTime(this.state.playerData?.shield_expire_date) : "None"}
            </a>

            <Dialog
                open={this.state.shieldModalVisible}
                onClose={this.hideShieldModal}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle id="draggable-dialog-title">
                    Edit shield expire date
                </DialogTitle>
                <DialogContent dividers>
                    <FormControl required fullWidth>
                        <DateTimePicker
                            label="Date"
                            value={this.state.shieldExpireValue}
                            onChange={this.changeShieldExpire}
                            renderInput={(params) => <TextField {...params} size="small"/>}
                            ampm={false}
                        />
                    </FormControl>
                </DialogContent>

                <DialogActions>
                    <Button disableElevation onClick={this.hideShieldModal} color="primary" variant="contained">
                        Cancel
                    </Button>
                    <Button disableElevation onClick={this.saveShieldExpire} color="primary" variant="contained">
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    }

    lastLoginModal() {
        return <React.Fragment>
            <a href="javascript:;" onClick={this.showLastLoginModal}>
                {Helpers.formatTimeAgo(this.state.playerData?.last_login)}
            </a>

            <Dialog
                open={this.state.lastLoginModalVisible}
                onClose={this.hideLastLoginModal}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle id="draggable-dialog-title">
                    Edit last login time
                </DialogTitle>
                <DialogContent dividers>
                    <FormControl required fullWidth>
                        <DateTimePicker
                            label="Date"
                            value={this.state.lastLoginValue}
                            onChange={this.changeLastLoginValue}
                            renderInput={(params) => <TextField {...params} size="small"/>}
                            ampm={false}
                        />
                    </FormControl>
                </DialogContent>

                <DialogActions>
                    <Button disableElevation onClick={this.cancel} color="primary" variant="contained">
                        Cancel
                    </Button>
                    <Button disableElevation onClick={this.saveLastLogin} color="primary" variant="contained">
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    }

    exportUserToStage = (userId) => {
        this.setState({exportInProgress: true}, async () => {
            try {
                const response = await axios.post(`${Config.getInstance.apiUrl}/api/user/copy`, {
                        userId: String(userId),
                    },
                    {
                        headers: {
                            Authorization: Helpers.getSessionId(),
                            env: this.props.activeEnv,
                        },
                    });

                this.setState({exportInProgress: false});
                PopupMessage.success("User successfully imported");
            } catch (error) {
                this.setState({exportInProgress: false});
                PopupMessage.error("Something went wrong!", 5, error);
            }
        });
    };

    sendNotification = async () => {
        if (!this.state.notificationTitle || !this.state.notificationDescription) {
            this.setState({noNotificationTitle: true, noNotificationDescription: true});
            return;
        }

        for (const fcm of this.state.playerData.fcm) {
            if (!fcm) {
                continue;
            }

            const data = {
                title: this.state.notificationTitle,
                body: this.state.notificationDescription,
                fcmToken: fcm,
            };

            try {
                const response = await axios.post(`${Config.getInstance.apiUrl}/api/user/send_notification`, {data},
                    {
                        headers: {
                            Authorization: Helpers.getSessionId(),
                            env: this.props.activeEnv,
                        },
                    });
            } catch (error) {
                PopupMessage.error("Something went wrong!", 5, error);
            }
        }

        this.setState({
            notificationModalVisible: false,
            notificationTitle: "",
            notificationDescription: "",
        });
    };

    saveShieldExpire = () => {
        const playerData = {...this.state.playerData};

        playerData.shield_expire_date = this.state.shieldExpireValue;

        this.setState({
            playerData,
            shieldModalVisible: false,
        });

        axios.put(`${Config.getInstance.apiUrl}/api/user/${this.state.playerId}/shield`, {
            value: this.state.shieldExpireValue,
        }, {
            headers: {
                Authorization: Helpers.getSessionId(),
                env: this.props.activeEnv,
            },
        }).catch(error => {
            PopupMessage.error("Something went wrong!", 5, error);
        });
    };

    saveLastLogin = () => {
        const playerData = this.state.playerData;

        this.setState({
            playerData: {
                ...playerData,
                last_login: this.state.lastLoginValue,
            },
            lastLoginModalVisible: false,
        });

        axios.put(`${Config.getInstance.apiUrl}/api/user/${this.state.playerId}/last_login`, {
            value: this.state.lastLoginValue,
        }, {
            headers: {
                Authorization: Helpers.getSessionId(),
                env: this.props.activeEnv,
            },
        }).catch(error => {
            PopupMessage.error("Something went wrong!", 5, error);
        });
    };

    cancel = () => {
        this.setState({
            notificationTitle: "",
            notificationDescription: "",
            notificationModalVisible: false,
            noNotificationTitle: false,
            noNotificationDescription: false,

            lastLoginModalVisible: false,
            shieldModalVisible: false,
            rechargeModalVisible: false,
            rechargeGems: 0
        });
    }

    acceptAvatar = async () => {
        try {
            if (!confirm("Are you sure you want to accept the avatar?")) {
                return;
            }

            await axios.post(`${Config.getInstance.apiUrl}/api/user/${this.state.playerData.id}/accept-avatar`, {}, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                    env: this.props.activeEnv,
                },
            });

            this.setState((state) => {
                if (!state.playerData.avatarChanges) {
                    state.playerData.avatarChanges = {
                        count: 0,
                        hasChanged: true,
                    };
                }

                state.playerData.avatarChanges.hasChanged = false;

                return state;
            });
        } catch (error) {
            PopupMessage.error("Something went wrong!", 5, error);
        }
    };

    acceptAvatarButton = () => {
        if (!this.state?.playerData?.avatarChanges) {
            return null;
        }

        if (!this.state?.playerData?.avatarChanges?.hasChanged) {
            return null;
        }

        return <Button disableElevation onClick={this.acceptAvatar} variant="contained" color="primary" size="small">
            Accept Avatar
        </Button>;
    };

    kickButton() {
        if (!this.state.dataLoaded) {
            return <Skeleton width={110} height={55}/>
        }

        return <Button disableElevation onClick={this.kickPlayer} variant="contained" color="warning" size="small">
            Kick Player
        </Button>
    }

    kickPlayer = () => {
        if (!confirm("Are you sure you want to kick the player out of the game? Their account will be automatically locked and you will need to unlock it manually")) {
            return;
        }

        axios.post(`${Config.getInstance.apiUrl}/api/user/${this.state.playerId}/kick`, {},
            {
                headers: {
                    Authorization: Helpers.getSessionId(),
                    env: this.props.activeEnv,
                },
            })
            .then(data => {
                PopupMessage.success("User successfully kicked out of the game");

                setTimeout(() => {
                    window.location.reload();
                }, 3000);
            })
            .catch(error => {
                PopupMessage.error("Something went wrong!", 5, error);
            });
    };

    unlinkDevice(deviceId: string) {
        if (confirm("Are you sure?")) {
            axios.post(`${Config.getInstance.apiUrl}/api/user/${this.state.playerId}/devices/unlink`, {
                deviceId,
            },
            {
                headers: {
                    Authorization: Helpers.getSessionId(),
                },
            })
            .then(_ => {
                PopupMessage.success("Device unlinked");

                const tempUserData = {...this.state.playerData};
                const index = tempUserData.devices.findIndex(device => device.device_id === deviceId);

                tempUserData.devices.splice(index, 1);

                this.setState({
                    playerData: tempUserData,
                })
            })
            .catch(error => {
                PopupMessage.error("Something went wrong!", 5, error);
            });
        }
    }

    banAndUnbanModals = () => {
        if (!this.state.dataLoaded) {
            return <Skeleton width={110} height={55}/>
        }

        if (this.canBan()) {
            return <div>
                <Button disableElevation onClick={this.showBanModal} variant="contained" color="secondary" size="small">
                    Ban Player
                </Button>

                <Dialog
                    open={this.state.banModalVisible}
                    onClose={this.hideBanModal}
                >
                    <DialogTitle>Are you sure?</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <p>Banned users can't log in, are removed from their family and matchmaking.</p>
                            <p>Banned player's data does not get erased and can be later unbanned.</p>

                            <FormControl style={{width: "100%"}}>
                                <InputLabel>
                                    Type
                                </InputLabel>
                                <Select
                                    value={this.state.banForm.type}
                                    onChange={(e) => this.banFormChange(e, "type", true)}
                                    style={{width: "100%"}}
                                    label="Type"
                                    inputProps={{
                                        name: "ban-type",
                                        id: "ban-type",
                                    }}
                                    size="small"
                                >
                                    <MenuItem value="1" key="1">Temporary</MenuItem>
                                    <MenuItem value="2" key="2">Permanent</MenuItem>
                                </Select>
                            </FormControl>

                            {this.state.banForm.type === 1 && <FormControl style={{width: "100%", marginTop: 20}}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DateTimePicker
                                        label="Expires At"
                                        value={this.state.banForm.expiresAt}
                                        onChange={this.banFormDateChange}
                                        renderInput={(params) => <TextField {...params} size="small"/>}
                                        ampm={false}
                                    />
                                </LocalizationProvider>
                            </FormControl>}

                            <FormControl style={{width: "100%", marginTop: 10}}>
                                <TextField
                                    required
                                    id="ban-reason"
                                    label="Reason"
                                    value={this.state.banForm.reason}
                                    onChange={(e) => this.banFormChange(e, "reason")}
                                    type="text"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    style={{width: "100%"}}
                                    margin="normal"
                                    size="small"
                                />
                            </FormControl>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Button disableElevation onClick={this.hideBanModal} color="primary">
                            Cancel
                        </Button>
                        <Button disableElevation onClick={this.banPlayer} disabled={!this.state.banForm.reason.trim()} color="secondary" variant="contained">
                            Ban
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>;
        }

        return <div>
            <Button disableElevation variant="contained" color="primary" onClick={this.showUnbanModal} size="small">
                Unban Player
            </Button>

            <Dialog
                open={this.state.unbanModalVisible}
                onClose={this.hideUnbanModal}
            >
                <DialogTitle>Are you sure?</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <p>You are about to unban this user.</p>
                        <p>Are you sure?</p>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button disableElevation onClick={this.hideUnbanModal} color="primary">
                        Cancel
                    </Button>
                    <Button disableElevation onClick={this.unbanPlayer} color="primary">
                        Unban
                    </Button>
                </DialogActions>
            </Dialog>
        </div>;
    };

    muteAndUnmuteModals = () => {
        if (!this.state.dataLoaded) {
            return <Skeleton width={110} height={55}/>
        }

        if (this.canMute()) {
            return <div>
                <Button disableElevation onClick={this.showMuteModal} variant="contained" color="secondary" size="small">
                    Mute Player
                </Button>

                <Dialog
                    open={this.state.muteModalVisible}
                    onClose={this.hideMuteModal}
                >
                    <DialogTitle>Are you sure?</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <p>Muted users can't send messages in chat.</p>
                        </DialogContentText>

                        <FormControl style={{width: "100%"}}>
                            <InputLabel>
                                Type
                            </InputLabel>
                            <Select
                                value={this.state.muteForm.type}
                                onChange={(e) => this.muteFormChange(e, "type", true)}
                                style={{width: "100%"}}
                                label="Type"
                                inputProps={{
                                    name: "mute-type",
                                    id: "mute-type",
                                }}
                                size="small"
                            >
                                <MenuItem value="1">Temporary</MenuItem>
                                <MenuItem value="2">Permanent</MenuItem>
                            </Select>
                        </FormControl>

                        {this.state.muteForm.type === 1 && <FormControl style={{width: "100%", marginTop: 20}}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DateTimePicker
                                    label="Expires At"
                                    value={this.state.muteForm.expiresAt}
                                    onChange={this.muteFormDateChange}
                                    renderInput={(params) => <TextField {...params} size="small"/>}
                                    ampm={false}
                                />
                            </LocalizationProvider>
                        </FormControl>}

                        <FormControl style={{width: "100%", marginTop: 10}}>
                            <TextField
                                required
                                id="mute-reason"
                                label="Reason"
                                value={this.state.muteForm.reason}
                                onChange={(e) => this.muteFormChange(e, "reason")}
                                type="text"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                style={{width: "100%"}}
                                margin="normal"
                                size="small"
                            />
                        </FormControl>

                    </DialogContent>
                    <DialogActions>
                        <Button disableElevation onClick={this.hideMuteModal} color="primary">
                            Cancel
                        </Button>
                        <Button disableElevation onClick={this.mutePlayer} color="secondary" variant="contained">
                            Mute
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>;
        }

        return <div>
            <Button disableElevation variant="contained" color="primary" onClick={this.showUnmuteModal} size="small">
                Unmute Player
            </Button>

            <Dialog
                open={this.state.unmuteModalVisible}
                onClose={this.hideUnmuteModal}
            >
                <DialogTitle>Are you sure?</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <p>You are about to unmute this user.</p>
                        <p>Are you sure?</p>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button disableElevation onClick={this.hideUnmuteModal} color="primary">
                        Cancel
                    </Button>
                    <Button disableElevation onClick={this.unmutePlayer} color="primary">
                        Unmute
                    </Button>
                </DialogActions>
            </Dialog>
        </div>;
    };

    renderDeleteAccountButton = (userId) => {
        if (!this.state.dataLoaded) {
            return <Skeleton width={110} height={55}/>
        }

        // Button with red color
        return <Button disableElevation variant="contained" color="error" onClick={() => this.deleteAccount(userId)} size="small">
            Delete Account
        </Button>;
    }

    deleteAccount = async (userId) => {
        if (confirm("Are you sure?")) {
            const response = await axios.post(`${Config.getInstance.apiUrl}/api/user/delete`, {
                userId
            },
            {
                headers: {
                    Authorization: Helpers.getSessionId(),
                },
            });

            if(response.data.success) {
                PopupMessage.success("Account successfully deleted");
                // Refresh page
                window.location.href = `/players/${userId}`;
            } else {
                PopupMessage.error(`Delete account failed: ${response.data.message}`);
                const from = response.data.from || "";
                if(from === "web") {
                    // Ask if user wants to delete account without calling web
                    if(confirm("Delete Account from Web failed. Do you want to delete account without calling web?")){
                        const response1 = await axios.post(`${Config.getInstance.apiUrl}/api/user/delete`, {
                            userId,
                            skipWebUser: true
                        },
                        {
                            headers: {
                                Authorization: Helpers.getSessionId(),
                            },
                        });
                        if(response1.data.success) {
                            PopupMessage.success("Account successfully deleted");
                            // Refresh page
                            window.location.href = `/players/${userId}`;
                        } else {
                            PopupMessage.error(`Delete account failed: ${response1.data.message}`);
                        }
                    }
                }
            }
        }
    };

    renderRemoveProfilePicture() {
        if (!this.state.dataLoaded) {
            return <Skeleton width={110} height={55}/>
        }

        return <React.Fragment>
            <Button disableElevation variant="contained" color="primary" onClick={() => this.toggleRemoveProfilePictureModal(true)}
                    size="small">
                Remove avatar
            </Button>

            <Dialog
                open={this.state.removeProfilePictureModalVisible}
                onClose={() => this.toggleRemoveProfilePictureModal(false)}
            >
                <DialogTitle>Are you sure?</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <p>Are you sure? It will set user profile picture to default avatar.</p>
                        <p>Are you sure?</p>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button disableElevation onClick={() => this.toggleRemoveProfilePictureModal(false)} color="primary">
                        Cancel
                    </Button>
                    <Button disableElevation onClick={this.removeProfilePicture} color="primary">
                        Remove avatar
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    };

    changeRechargeGems = (e: any) => {
        const amount = e.target.value;
        this.setState({
            rechargeGems: amount,
        });
    };

    addRechargeGems = async () => {
        try {
            const response = await axios.post(`${Config.getInstance.apiUrl}/api/user/${this.state.playerId}/increase_recharge`, {
                gems: this.state.rechargeGems
            }, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                    env: this.props.activeEnv,
                },
            });

            const playerData = this.state.playerData;

            playerData.meta.recharge_deal = response.data.recharge_deal;

            this.setState({
                playerData
            });
        } catch (e) {
            // tslint:disable-next-line:no-console
            console.error(e);

            PopupMessage.error("Something went wrong!");
        }

        this.setState({
            rechargeModalVisible: false,
            rechargeGems: 0
        });
    };

    rechargeModal = () =>
        <div>
            <Dialog
                open={this.state.rechargeModalVisible}
                onClose={this.hideNotificationModal}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle id="draggable-dialog-title">
                    Add Gems to the Recharge deal
                </DialogTitle>
                <DialogContent dividers>
                    <FormControl required fullWidth>
                        <TextField
                            required
                            error={this.state.noNotificationTitle}
                            id="reward-title"
                            label="Gems"
                            value={this.state.rechargeGems}
                            onChange={this.changeRechargeGems}
                            type="text"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            margin="normal"
                        />
                    </FormControl>
                </DialogContent>

                <DialogActions>
                    <Button disableElevation onClick={this.cancel} color="primary" variant="contained">
                        Cancel
                    </Button>
                    <Button disableElevation onClick={this.addRechargeGems} color="primary" variant="contained">
                        Add
                    </Button>
                </DialogActions>
            </Dialog>
        </div>;

    getAllianceLink = () => {
        if (this.state.playerData.squad && this.state.playerData.squad.id) {
            return <NavLink to={`/alliances/${this.state.playerData.squad.id}`}>
                {this.state.playerData.squad.name}
            </NavLink>;
        }

        return "-";
    };

    printMuteStatus = (item: any) => {
        const {classes} = this.props;

        const banType: number = item?.muted?.type || 0;
        const expiresAt: string = item?.muted?.expiresAt || null;
        const reason: string = item?.muted?.reason || "";

        const muted = banType === 2 || (banType === 1 && new Date(expiresAt).getTime() > new Date().getTime());
        if (!muted) {
            return "Not muted";
        }

        return <Box className={classes.banned}>
            <div><b>{banType === 1 ? `TEMPORARY muted until ${moment(expiresAt).format("DD.MM.YYYY HH:MM")}!` : "PERMANENT banned"}</b></div>
            <div><b>Reason:</b> {reason}</div>
        </Box>;
    };

    printBanStatus = (item: any) => {
        const {classes} = this.props;

        const banType: number = item?.ban_type || 0;
        const expiresAt: string = item?.ban_expires_at || null;
        const reason: string = item?.ban_reason || "";
        const banned = banType === 2 || (banType === 1 && new Date(expiresAt).getTime() > new Date().getTime());

        if (!banned) {
            return "Not banned";
        }

        return <Box className={classes.banned}>
            <div><b>{banType === 1 ? `TEMPORARY banned until ${moment(expiresAt).format("DD.MM.YYYY HH:MM")}!` : "PERMANENT banned"}</b></div>
            <div><b>Reason:</b> {reason}</div>
        </Box>;
    };

    getLeagueNameByRank = (rank) => {
        const leagues = getGlobalVar("LEAGUES");
        const leagueDivision = leagues.find(item => item.min <= +rank && item.max >= +rank);

        return leagueDivision ? leagueDivision.key.split("_").join(" ") : "Unknown";
    };

    premiumIsEnabled = () => Helpers.timeLeft(this.state.playerData?.vip_system?.premium?.expiresAt) > 0;

    formatAllianceRole = (role: number) => {
        switch (role) {
            case 0:
                return "Boss";
            case 1:
                return "Adviser";
            case 2:
                return "Commander";
            case 3:
                return "Soldier";
            case 4:
                return "Member";
            default:
                return "Unknown";
        }
    };

    formatAllianceStatus = (status: number) => {
        switch (status) {
            case 1:
                return "Never joined alliance";
            case 2:
                return "Joined first alliance";
            case 3:
                return "Joined multiple alliances";
            default:
                return "Unknown";
        }
    };

    handlePlayerDataChange = (name, value, type = "string") => {
        this.setState(prevState => {
            const temp = prevState.playerData;
            temp[name] = value;

            return {
                playerData: temp,
            };
        }, () => {
            axios.put(`${Config.getInstance.apiUrl}/api/user/${this.state.playerId}/data`, {
                object: "root",
                input_type: type,
                parameter: name,
                value,
            }, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                },
            })
            .catch(() => {
                PopupMessage.error("Couldn't save data!");
            });
        });
    }

    handleCountryChange(country) {
        this.setState(prevState => {
            const temp = prevState.playerData;
            temp.country = country.code;

            return {
                playerData: temp,
            };
        }, () => {
            axios.put(`${Config.getInstance.apiUrl}/api/user/${this.state.playerId}/data`, {
                object: "root",
                input_type: "string",
                parameter: "country",
                value: country.code,
            }, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                },
            })
            .catch(() => {
                PopupMessage.error("Couldn't save country!");
            });
        });
    }

    onTempEditData = (name, value) => {
        this.setState(prevState => {
            const temp = prevState.tempValues;
            temp[name] = value;

            return {
                tempValues: temp,
            };
        });
    };

    onBoosterExpireEdit = (index, value) => {
        this.setState(prevState => {
            const temp = prevState.playerData;
            const dateSplit = value.split("T");
            const timeSplit = dateSplit[1].split(":");
            const endDate = moment(dateSplit[0], "YYYY-MM-DD")
                .utcOffset(0)
                .add(1, "day") // fuuu
                .hour(timeSplit[0])
                .minute(timeSplit[1])
                .toDate();

            const boosterConfig = getGlobalVar("ITEMS").find(item => item.id === temp.meta.active_boosters[index].id);

            temp.meta.active_boosters[index].start = moment(endDate).subtract(boosterConfig.seconds, "seconds");
            temp.meta.active_boosters[index].expire = endDate;

            return {
                playerData: temp,
            };
        }, () => {
            axios.put(`${Config.getInstance.apiUrl}/api/user/${this.state.playerId}/data`, {
                object: "meta",
                input_type: "array",
                parameter: "active_boosters",
                value: this.state.playerData.meta.active_boosters,
            }, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                },
            })
                .catch(() => {
                    PopupMessage.error("Something went wrong!");
                });
        });
    };

    resetTempValue = (name) => {
        this.setState(prevState => {
            const temp = prevState.tempValues;
            delete temp[name];

            return {
                tempValues: temp,
            };
        });
    };

    getGoldAndOil = () => {
        const {parsedEnviroment} = this.state;
        const buildings = parsedEnviroment?.buildings || [];

        let gold = 0;
        let oil = 0;

        buildings.forEach(building => {
            const id = building.id;

            switch (id) {
                case 5200:
                    // Gold Storage
                    gold += building.capacity || 0;
                    break;
                case 5211:
                    // Oil Storage
                    oil += building.capacity || 0;
                    break;
                case 5000:
                    // Gold
                    gold += building.cash || 0;
                    oil += building.energy || 0;
                    break;
            }
        });

        return {
            gold,
            oil,
        };
    };

    saveTempValue = async (data: UpdateProps) => {
        let valueToSafe = this.state.tempValues[data.parameters];

        if (data.type === "boolean") {
            valueToSafe = valueToSafe === "true";
        }

        this.setState(prevState => {
            const temp = prevState.playerData;
            let rootObject = temp;

            if (data.object === "meta") {
                rootObject = temp.meta;
            }

            if (data.inputType === "json") {
                Helpers.updateObject(rootObject, data.parameters, valueToSafe);
            } else if (data.inputType === "boolean") {
                rootObject[data.parameters] = valueToSafe === true;
            } else {
                rootObject[data.parameters] = valueToSafe;
            }

            axios.put(`${Config.getInstance.apiUrl}/api/user/${this.state.playerId}/data`, {
                object: data.object,
                input_type: data.inputType,
                parameter: data.parameters,
                value: valueToSafe,
            }, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                },
            }).then(() => {
                if(data.parameters === "rubies") {
                    // Sync rubies with web
                    // Call API
                    const url = `${Config.getInstance.apiUrl}/api/users/sync-web-sapphire/${this.state.playerId}`;
    
                    axios.post(url, {},
                        {
                            headers: {
                                Authorization: Helpers.getSessionId(),
                                env: this.props.activeEnv,
                            },
                        }
                    ).catch(error => {
                        PopupMessage.error("Sync rubies with web Error", error);
                    });
                }
            }).catch(() => {
                PopupMessage.error("Something went wrong!");
            });

            return {
                playerData: temp,
            };
        }, () => {
            this.resetTempValue(data.parameters);
        });
    };

    editData = (data: UpdateProps) => {
        // Don't allow to edit data if user is online
        if (this.state.playerData.is_online) {
            switch (data.type) {
                case "date":
                    return <div>{moment(data.value).format("DD.MM.YYYY HH:MM:ss") + ""}</div>;
                default:
                    return <div>{data.value + ""}</div>;
            }
        }

        let buttonsPosition = {};
        let input = null;

        if (data.type === "number") {
            input = <TextField
                type="number"
                value={this.state.tempValues[data.parameters] || data.value}
                onChange={(e) => this.onTempEditData(data.parameters, +e.target.value)}
                size="small"
            />

            buttonsPosition = {
                left: 220,
                top: 7
            };
        }

        if (data.type === "boolean") {
            input = <Select
                value={this.state.tempValues[data.parameters] || data.value}
                onChange={(e) => this.onTempEditData(data.parameters, e.target.value)}
                size="small"
            >
                <MenuItem value="true">True</MenuItem>
                <MenuItem value="false">False</MenuItem>
            </Select>;

            buttonsPosition = {
                left: 65,
                top: 6
            };
        }

        if (data.type === "string") {
            input = <TextField
                type="text"
                value={this.state.tempValues[data.parameters] || data.value}
                onChange={(e) => this.onTempEditData(data.parameters, e.target.value)}
                size="small"
            />

            buttonsPosition = {
                left: 180,
                top: 0
            };
        }

        if (data.type === "date") {
            input = <DateTimePicker
                value={this.state.tempValues[data.parameters] || data.value}
                onChange={date => this.onTempEditData(data.parameters, date)}
                renderInput={(params) => <TextField {...params} size="small"/>}
                ampm={false}
            />

            buttonsPosition = {
                left: 250,
                top: 8
            };
        }

        if (data.type === "select") {
            input = <Select
                value={this.state.tempValues[data.parameters] || data.value}
                onChange={(e) => this.onTempEditData(data.parameters, e.target.value)}
                size="small"
            >
                {data.items}
            </Select>;

            buttonsPosition = {
                display: "inline-flex"
            };
        }

        return <div style={{position: "relative"}}>
            {input}

            {this.state.tempValues[data.parameters] &&
            <div style={{position: "absolute", minWidth: 50, ...buttonsPosition}}>
                <div style={successButtonStyle}>
                    <CheckCircleOutlineIcon onClick={() => this.saveTempValue(data)}/>
                </div>
                <div style={cancelButtonStyle}>
                    <HighlightOffIcon onClick={() => this.resetTempValue(data.parameters)}/>
                </div>
            </div>}
        </div>;
    };

    renderPageHeader = () =>
        <Grid container>
            <Grid item xs={3}>
                <div className="player-avatar">
                    <EditPlayerAvatar
                        {...this.props}
                        playerData={this.state.playerData}
                        handlePlayerDataChange={this.handlePlayerDataChange}
                    />
                </div>
                <div className="player-username">
                    <EditUsername
                        {...this.props}
                        playerData={this.state.playerData}
                        handlePlayerDataChange={this.handlePlayerDataChange}
                        dataLoaded={this.state.dataLoaded}
                    />
                </div>
            </Grid>
            <Grid item xs={9} className="header--buttons">
                <div style={{display: "inline-block"}}>
                    {this.acceptAvatarButton()}
                </div>
                <div style={{display: "inline-block", marginLeft: 10}}>
                    {this.kickButton()}
                </div>
                <div style={{display: "inline-block", marginLeft: 10}}>
                    {this.banAndUnbanModals()}
                </div>
                <div style={{display: "inline-block", marginLeft: 10}}>
                    {this.muteAndUnmuteModals()}
                </div>
                {!(this.state.playerData.avatar > 0) && (
                    <div style={{display: "inline-block", marginLeft: 10}}>
                        {this.renderRemoveProfilePicture()}
                    </div>
                )}
                <div style={{display: "inline-block", marginLeft: 10}}>
                    <MessagePlayer
                        playerId={this.props.match.params.playerId}
                        dataLoaded={this.state.dataLoaded}
                    />
                </div>
                <div style={{display: "inline-block", marginLeft: 10}}>
                    {this.notificationModal()}
                </div>
                <div style={{display: "inline-block", marginLeft: 10}}>
                    <ExportPlayer
                        playerData={this.state.playerData}
                        socket={this.props.socket}
                        activeUser={this.props.activeUser}
                        dataLoaded={this.state.dataLoaded}
                    />
                </div>
                <div style={{display: "inline-block", marginLeft: 10}}>
                    <TransferPlayer
                        playerData={this.state.playerData}
                        activeUser={this.props.activeUser}
                        dataLoaded={this.state.dataLoaded}
                    />
                </div>

                {this.props.activeEnv === "prod" && <div style={{display: "inline-block", marginLeft: 5}}>
                    <Button disableElevation onClick={() => this.exportUserToStage(this.state.playerData.id)} variant="contained"
                            size="small">
                        {this.state.exportInProgress ?
                            <CircularProgress style={{width: 21, height: 21}}/> : "Export to stage"}
                    </Button>
                </div>}
                <div style={{display: "inline-block", marginLeft: 10}}>
                    {this.renderDeleteAccountButton(this.state.playerData.id)}
                </div>
                
            </Grid>
        </Grid>;

    renderValue(value) {
        if (!this.state.dataLoaded) {
            return <Skeleton/>
        }

        return value;
    }

    renderGeneral() {
        const resourceData = this.getGoldAndOil();
        console.log(`resourceData`, resourceData);

        const rankSubmitForm = () => {
            if ((this.state.playerData.rank || 0) !== this.state.originalRank) {
                return <div style={{position: "absolute", left: 320, top: 25, minWidth: 50}}>
                    <div style={successButtonStyle}>
                        <CheckCircleOutlineIcon onClick={() => this.saveRank()}/>
                    </div>
                    <div style={cancelButtonStyle}>
                        <HighlightOffIcon onClick={() => this.resetRank()}/>
                    </div>
                </div>;
            }

            return null;
        };

        return <Grid container>
            <Grid item container sm={4} style={{ padding: "0 10px" }}>
                <Paper elevation={0}>
                    <CardHeader title="User information"/>

                    <Table aria-label="simple table" style={{tableLayout: "inherit"}}>
                        <TableBody>
                            <TableRow>
                                <TableCell component="th" scope="row" style={{ width: 210 }}>Player Id</TableCell>
                                <TableCell align="left">{this.renderValue(this.state?.playerData?.id)}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row" style={{ width: 210 }}>Web User Id</TableCell>
                                <TableCell align="left">{this.renderValue(this.state?.playerData?.web_user_id || "Not linked")}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row"  style={{ width: 210 }}>Player Tag</TableCell>
                                <TableCell align="left">{this.renderValue(this.state?.playerData?.tag)}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">Created</TableCell>
                                <TableCell align="left">
                                    {this.renderValue(Helpers.formatDateWithTime(this.state?.playerData?.created_at))}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">Last login</TableCell>
                                <TableCell align="left">
                                    {this.renderValue(this.lastLoginModal())}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">Shield expire</TableCell>
                                <TableCell align="left">
                                    {this.renderValue(this.shieldModal())}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">Ban status</TableCell>
                                <TableCell align="left">
                                    <div style={{ display: "flex" }}>
                                        <div>
                                            {this.renderValue(this.printBanStatus(this.state.playerData))}
                                        </div>
                                        <div style={{ justifyContent: "center", alignItems: "center", display: "flex" }}>
                                            <PunishmentHistory
                                                {...this.props}
                                                playerData={this.state.playerData}
                                                dataLoaded={this.state.dataLoaded}
                                                type="ban"
                                            />
                                        </div>
                                    </div>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">Mute status</TableCell>
                                <TableCell align="left">
                                    <div style={{ display: "flex" }}>
                                        <div>
                                            {this.renderValue(this.printMuteStatus(this.state.playerData))}
                                        </div>
                                        <div style={{ justifyContent: "center", alignItems: "center", display: "flex" }}>
                                            <PunishmentHistory
                                                {...this.props}
                                                playerData={this.state.playerData}
                                                dataLoaded={this.state.dataLoaded}
                                                type="mute"
                                            />
                                        </div>
                                    </div>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">Country</TableCell>
                                <TableCell align="left">
                                    {this.renderValue(<Autocomplete
                                        style={{ display: "inline-block", minWidth: 200, padding: "8px 5px 0 0" }}
                                        onChange={(_, newValue) => this.handleCountryChange(newValue)}
                                        value={CountryCodes.find(country => country.code === this.state?.playerData?.country)}
                                        options={CountryCodes.sort((a, b) => -b.name.localeCompare(a.name))}
                                        getOptionLabel={option => option?.name || ""}
                                        disableClearable={true}
                                        renderOption={(props, item) => (
                                            <Box component="li" {...props}>
                                                <ReactCountryFlag countryCode={item.code} svg={true}/>
                                                <span style={{ marginLeft: 7, fontSize: 15 }}>{item.name}</span>
                                            </Box>
                                        )}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                size="small"
                                            />
                                        }
                                    />)}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">Locale</TableCell>
                                <TableCell align="left">
                                    {this.renderValue(this.state?.playerData?.meta?.locale)}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">App version</TableCell>
                                <TableCell align="left">
                                    {this.renderValue(this.state?.playerData?.app_version)}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">Registered App version</TableCell>
                                <TableCell align="left">
                                    {this.renderValue(this.state?.playerData?.register_app_version || "Unknown")}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">Family reward claimed</TableCell>
                                <TableCell align="left">
                                    {this.renderValue(this.state?.playerData?.family_reward_claimed ? "Yes" : "No")}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">Core level</TableCell>
                                <TableCell align="left">
                                    {this.renderValue(this.state?.playerData?.headquarter_level)}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">Alliance hideout repaird?</TableCell>
                                <TableCell align="left">
                                    {this.renderValue(this.state?.playerData?.hideout_repaired ? "Yes" : "No")}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">Username changes</TableCell>
                                <TableCell align="left">
                                    {this.renderValue(this.state.playerData?.meta?.username_changes)}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">Units donated</TableCell>
                                <TableCell align="left">
                                    {this.renderValue(this.state?.playerData?.meta?.units_donation_donated || 0)}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">Units received</TableCell>
                                <TableCell align="left">
                                    {this.renderValue(this.state?.playerData?.meta?.units_donation_received || 0)}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">App rating</TableCell>
                                <TableCell align="left">
                                    {this.renderValue(this.state?.playerData?.meta?.app_rating_reward ?
                                        this.state?.playerData?.meta?.app_rating_reward?.taken ? "Yes" : "No" :
                                        "No"
                                    )}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">Avatar changes</TableCell>
                                <TableCell align="left">
                                    {this.renderValue(this.state?.playerData?.meta?.avatar_changes?.count || 0)}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">Muted players</TableCell>
                                <TableCell align="left">
                                    {this.renderValue(this.state?.playerData?.meta?.muted_players?.length || 0)}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">Time played</TableCell>
                                <TableCell align="left">
                                    {this.renderValue(Helpers.fancyTimeFormat(this.state?.playerData?.play_time))}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">Locked</TableCell>
                                <TableCell align="left">
                                    {this.renderValue(this.editData({
                                        type: "boolean",
                                        value: this.state?.playerData?.locked,
                                        inputType: "boolean",
                                        parameters: "locked",
                                        object: "root"
                                    }))}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Paper>

                <Paper style={{marginTop: 20}} elevation={0}>
                    <CardHeader title="VIP"/>

                    <Table aria-label="simple table" style={{tableLayout: "inherit"}}>
                        <TableBody>
                            <TableRow>
                                <TableCell component="th" scope="row" className="userTable-cell">Level</TableCell>
                                <TableCell align="left">
                                    {this.renderValue(this.state?.playerData?.vip_system?.level)}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row" className="userTable-cell">Points</TableCell>
                                <TableCell align="left" style={{position: "relative"}}>
                                    {this.renderValue(this.editData({
                                        type: "number",
                                        value: this.state?.playerData?.vip_system?.points,
                                        inputType: "json",
                                        parameters: "vip_system.points",
                                        object: "root"
                                    }))}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row" className="userTable-cell">Premium</TableCell>
                                <TableCell align="left">
                                    {this.renderValue(this.premiumIsEnabled() ? "True" : "False")}
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell component="th" scope="row" className="userTable-cell">Premium end date</TableCell>
                                <TableCell align="left">
                                    {this.renderValue(this.editData({
                                        type: "date",
                                        value: this.state.playerData?.vip_system?.premium?.expiresAt || new Date(),
                                        inputType: "json",
                                        parameters: "vip_system.premium.expiresAt",
                                        object: "root"
                                    }))}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Paper>

                {this.state.playerData?.providers && this.state?.playerData?.providers?.length > 0 &&
                    <Paper style={{marginTop: 20, paddingBottom: 10}} elevation={0}>
                        <CardHeader title="Providers"/>

                        {this.state.playerData.providers.map(provider =>
                            <Paper style={{margin: "10px 15px"}} elevation={0} key={provider.key}>
                                <Table aria-label="simple table"
                                    style={{marginBottom: 20, tableLayout: "inherit"}}>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell component="th" scope="row">Key</TableCell>
                                            <TableCell  align="left" style={{wordBreak: "break-all"}}>
                                                {provider.key}
                                            </TableCell>
                                        </TableRow>

                                        <TableRow>
                                            <TableCell component="th" scope="row">Id</TableCell>
                                            <TableCell align="left" style={{wordBreak: "break-all"}}>
                                                {provider.provider_id}
                                            </TableCell>
                                        </TableRow>

                                        {provider.name && <TableRow>
                                            <TableCell component="th" scope="row">Name</TableCell>
                                            <TableCell align="left" style={{wordBreak: "break-all"}}>
                                                {provider.name}
                                            </TableCell>
                                        </TableRow>}

                                        {provider.email && <TableRow>
                                            <TableCell component="th" scope="row">Email</TableCell>
                                            <TableCell align="left" style={{wordBreak: "break-all"}}>
                                                {provider.email}
                                            </TableCell>
                                        </TableRow>}
                                    </TableBody>
                                </Table>
                            </Paper>
                        )}
                    </Paper>
                }

                {this.state?.playerData?.meta?.settings?.length > 0 &&
                    <Paper style={{marginTop: 20}} elevation={0}>
                        <CardHeader title="Settings"/>

                        <Table aria-label="simple table" style={{marginBottom: 20}}>
                            <TableBody>
                                {this.state.playerData.meta?.settings && Object.keys(this.state.playerData.meta.settings).map((key) =>
                                    <TableRow key={key}>
                                        <TableCell component="th" scope="row">{key}</TableCell>
                                        <TableCell align="left">
                                            {typeof this.state.playerData.meta.settings[key] === "boolean" ?
                                                this.state.playerData.meta.settings[key] ? "True" : "False"
                                                : this.state.playerData.meta.settings[key]
                                            }
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </Paper>
                }

                {this.state?.playerData?.meta?.bucket_testing?.length > 0 &&
                    <Paper style={{marginTop: 20}} elevation={0}>
                        <CardHeader title="Bucket testing"/>

                        <Table aria-label="simple table" style={{marginBottom: 20}}>
                            <TableBody>
                                {this.state.playerData.meta?.bucket_testing && this.state.playerData.meta.bucket_testing.map(data =>
                                    <TableRow key={data.id}>
                                        <TableCell component="th" scope="row">{data.id}</TableCell>
                                        <TableCell align="left">{data.version}</TableCell>
                                    </TableRow>
                                )}

                                {!this.state.playerData.meta?.bucket_testing || this.state.playerData.meta.bucket_testing.length === 0 &&
                                <TableRow>
                                    <TableCell colSpan={2}>
                                        <Alert severity="info">None</Alert>
                                    </TableCell>
                                </TableRow>}
                            </TableBody>
                        </Table>
                    </Paper>
                }

                <Paper style={{marginTop: 20}} elevation={0}>
                    <CardHeader title="Install source"/>

                    <Table aria-label="simple table" style={{marginBottom: 20}}>
                        <TableBody>
                            <TableRow>
                                <TableCell component="th" scope="row">Network</TableCell>
                                <TableCell
                                    className="userTable-cell"
                                    align="left"
                                >
                                    {this.renderValue(this.state?.playerData?.meta?.install_source?.network || "-")}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row" style={{ width: 150 }}>Campaign</TableCell>
                                <TableCell
                                    className="userTable-cell"
                                    align="left"
                                >
                                    {this.renderValue(this.state?.playerData?.meta?.install_source?.campaign || "-")}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">Source type</TableCell>
                                <TableCell
                                    className="userTable-cell"
                                    align="left"
                                >
                                    {this.renderValue(this.state?.playerData?.meta?.install_source?.source_type || "-")}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Paper>
            </Grid>

            <Grid item container sm={4} style={{ padding: "0 10px" }}>
                {this.state?.playerData?.squad && <Paper elevation={0}>
                    <CardHeader title="Alliance"/>

                    <Table aria-label="simple table" style={{tableLayout: "inherit"}}>
                        <TableBody>
                            <TableRow>
                                <TableCell component="th" scope="row">Name</TableCell>
                                <TableCell align="left">
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <CoatOfArms emblem={this.state.playerData.squad.flag}/>
                                        {this.getAllianceLink()}
                                    </div>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">Tag</TableCell>
                                <TableCell align="left">{this.state.playerData.squad.tag}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">Members</TableCell>
                                <TableCell align="left">
                                    {this.state.playerData.squad.members_count}/{this.state.playerData.squad.max_members}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">Role</TableCell>
                                <TableCell
                                    align="left">{this.formatAllianceRole(this.state.playerData.squad_role)}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">Join date</TableCell>
                                <TableCell
                                    align="left">{Helpers.formatDateWithTime(this.state.playerData.squad_join_date)}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">Status</TableCell>
                                <TableCell
                                    align="left">{this.formatAllianceStatus(this.state.playerData.squad_current_status)}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Paper>}

                <Paper style={{paddingBottom: 10, marginTop: this.state?.playerData?.squad ? 30 : 0}} elevation={0}>
                    <CardHeader title="Devices"/>

                    {this.state?.playerData?.devices && this.state?.playerData?.devices.map(device =>
                        <Paper style={{margin: "10px 15px"}} key={device.device_id}>
                            <Table aria-label="simple table"
                                style={{marginBottom: 20, tableLayout: "inherit"}}>
                                <TableBody>
                                    <TableRow>
                                        <TableCell component="th" scope="row">Device Id</TableCell>
                                        <TableCell align="left"
                                                style={{wordBreak: "break-all"}}>{device.device_id}</TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell component="th" scope="row">Store</TableCell>
                                        <TableCell align="left">{Helpers.capitalizeFirstLetter(device.store)}</TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell component="th" scope="row">Platform</TableCell>
                                        <TableCell
                                            align="left">{device.is_android ? "Android" : "iOS"}</TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell component="th" scope="row">Notifications</TableCell>
                                        <TableCell
                                            align="left">{device.fcm_token ? "Enabled" : "Disabled"}</TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell component="th" scope="row">Device model</TableCell>
                                        <TableCell align="left"
                                                style={{wordBreak: "break-all"}}>{device.device_model}</TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell component="th" scope="row">Device make</TableCell>
                                        <TableCell align="left"
                                                style={{wordBreak: "break-all"}}>{device.device_make}</TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell component="th" scope="row">OS Version</TableCell>
                                        <TableCell
                                            align="left">{device.device_platform_version}</TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell component="th" scope="row">Device ram</TableCell>
                                        <TableCell align="left">{device.device_ram}</TableCell>
                                    </TableRow>

                                    {
                                        /*
                                    <TableRow>
                                        <TableCell component="th" scope="row" colSpan={2}>
                                            <Button size="small" variant="contained" onClick={() => this.unlinkDevice(device.device_id)}>Unlink</Button>
                                        </TableCell>
                                    </TableRow>
                                    */
                                    }
                                </TableBody>
                            </Table>
                        </Paper>
                    )}
                </Paper>

                <Paper style={{marginTop: 20}} elevation={0}>
                    <CardHeader title="Matchmaking"/>

                    <Table aria-label="simple table" style={{tableLayout: "inherit"}}>
                        <TableBody>
                            <TableRow>
                                <TableCell component="th" scope="row">Building weight</TableCell>
                                <TableCell  align="left">
                                    {this.renderValue(this.state?.playerData?.building_weight)}
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell component="th" scope="row">Attacks win</TableCell>
                                <TableCell align="left">
                                    {this.renderValue(this.state?.playerData?.attacks_win)}
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell component="th" scope="row">Attacks lost</TableCell>
                                <TableCell align="left">
                                    {this.renderValue(this.state?.playerData?.attacks_lose)}
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell component="th" scope="row">Defense win</TableCell>
                                <TableCell align="left">
                                    {this.renderValue(this.state?.playerData?.defense_win)}
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell component="th" scope="row">Defense lost</TableCell>
                                <TableCell align="left">
                                    {this.renderValue(this.state?.playerData?.defense_lose)}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Paper>

                <Paper style={{marginTop: 20}} elevation={0}>
                    <CardHeader title="Timeouts"/>

                    <Table aria-label="simple table" style={{marginBottom: 20}}>
                        <TableBody>
                            {this.state?.playerData?.meta?.timeouts && Object.keys(this.state?.playerData?.meta?.timeouts).map((key) =>
                                <TableRow key={key}>
                                    <TableCell component="th" scope="row">{key}</TableCell>
                                    <TableCell align="left">
                                        {this.editData({
                                            type: "date",
                                            value: this.state.playerData.meta.timeouts[key],
                                            inputType: "json",
                                            parameters: `timeouts.${key}`,
                                            object: "meta"
                                        })}
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </Paper>

                <Paper style={{marginTop: 20}} elevation={0}>
                    <CardHeader title="Daily delivery"/>

                    <Table aria-label="simple table" style={{marginBottom: 20}}>
                        <TableBody>
                            <TableRow>
                                <TableCell component="th" scope="row">Repaired</TableCell>
                                <TableCell align="left">
                                    {this.renderValue(this.editData({
                                        type: "boolean",
                                        value: this.state?.playerData?.meta?.daily_delivery?.repaired,
                                        inputType: "json",
                                        parameters: "daily_delivery.repaired",
                                        object: "meta"
                                    }))}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">Tier</TableCell>
                                <TableCell align="left">
                                    {this.renderValue(this.editData({
                                        type: "number",
                                        value: this.state.playerData?.meta?.daily_delivery?.tier,
                                        inputType: "json",
                                        parameters: "daily_delivery.tier",
                                        object: "meta"
                                    }))}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">Next tier available</TableCell>
                                <TableCell align="left">
                                    {this.renderValue(this.state?.playerData?.meta?.daily_delivery?.nextTierAvailable ?
                                        Helpers.formatDateWithTime(this.state?.playerData?.meta?.daily_delivery?.nextTierAvailable) :
                                        "Available"
                                    )}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">First prize collected</TableCell>
                                <TableCell align="left">
                                    {this.renderValue(this.state?.playerData?.meta?.daily_delivery?.firstPrizeCollected ? "True" : "False")}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Paper>
            </Grid>

            <Grid item container sm={4} style={{ padding: "0 10px" }}>
                <Paper elevation={0}>
                    <CardHeader title="Quick update"/>

                    <Table aria-label="simple table" style={{tableLayout: "inherit"}}>
                        <TableBody>
                            <TableRow>
                                <TableCell component="th" scope="row">Gems</TableCell>
                                <TableCell align="left" style={{position: "relative"}}>
                                    {this.renderValue(this.editData({
                                        type: "number",
                                        value: this.state?.playerData?.rubies,
                                        inputType: "string",
                                        parameters: "rubies",
                                        object: "root"
                                    }))}
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell component="th" scope="row">Ruby</TableCell>
                                <TableCell align="left">
                                    <div style={{marginBottom: 8}}>
                                        {typeof this.state?.playerData?.ruby_balance === "number"
                                            ? this.state.playerData.ruby_balance.toLocaleString()
                                            : "Not linked"}
                                    </div>
                                </TableCell>
                                <TableCell align="left" style={{position: "relative"}}>
                                <PlayerUpdateRuby
                                        playerId={this.state.playerId}
                                        currentRuby={this.state?.playerData?.ruby_balance}
                                    />
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell component="th" scope="row">Power</TableCell>
                                <TableCell align="left" style={{position: "relative"}}>
                                    {this.renderValue(this.editData({
                                        type: "number",
                                        value: this.state?.playerData?.current_power,
                                        inputType: "string",
                                        parameters: "current_power",
                                        object: "root"
                                    }))}
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell component="th" scope="row">Rank</TableCell>
                                <TableCell align="left" style={{position: "relative"}}>
                                    {this.renderValue(
                                        <div>
                                            {Helpers.conditionPrint(this.state?.playerData?.is_online, <div
                                                style={{ float: "left" }}>
                                                <TextField
                                                    type="number"
                                                    value={this.state?.playerData?.rank || 0}
                                                    onChange={(e) => this.changeRank(e)}
                                                    size="small"
                                                    InputLabelProps={{
                                                        step: 10,
                                                    }}
                                                />

                                                {rankSubmitForm()}
                                            </div>, this.state?.playerData?.rank)}

                                            <span style={{marginLeft: 10, float: "left", marginTop: 11 }}>
                                                [{this.getLeagueNameByRank(this.state?.playerData?.rank || 0)}]
                                            </span>
                                        </div>
                                    )}
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell component="th" scope="row">Gold</TableCell>
                                <TableCell align="left" style={{position: "relative"}}>
                                    {resourceData.gold}
                                </TableCell>
                                <TableCell align="left" style={{position: "relative"}}>
                                    <TextField
                                        value={this.state.updateGoldValue || 0}
                                        onChange={(e) => this.onChangeUpdateValue(e, "updateGoldValue")}
                                        size="small"
                                    />
                                </TableCell>
                                <TableCell align="left" style={{position: "relative"}}>
                                    <Button 
                                    disableElevation 
                                    onClick={(e) => this.onUpdateResource("updateGoldValue")} 
                                    variant="contained" 
                                    size="small">
                                        Update
                                    </Button>
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell component="th" scope="row">Oil</TableCell>
                                <TableCell align="left" style={{position: "relative"}}>
                                    {resourceData.oil}
                                </TableCell>
                                <TableCell align="left" style={{position: "relative"}}>
                                    <TextField
                                        value={this.state.updateOilValue || 0}
                                        onChange={(e) => this.onChangeUpdateValue(e, "updateOilValue")}
                                        size="small"
                                    />
                                </TableCell>
                                <TableCell align="left" style={{position: "relative"}}>
                                    <Button 
                                    disableElevation 
                                    onClick={(e) => this.onUpdateResource("updateOilValue")} 
                                    variant="contained" 
                                    size="small">
                                        Update
                                    </Button>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Paper>

                {/* <Paper style={{ overflow: "hidden", marginTop: 20, display: "inline-block", width: "100%" }} elevation={0}>
                    <CardHeader title="Latest activity"/>

                    <PlayerLatestActivity
                        activeEnv={this.props.activeEnv}
                        playerId={this.state.playerId}
                        onTabChange={this.onTabChange}
                    />
                </Paper>

                <Paper style={{ overflow: "hidden", marginTop: 20, display: "inline-block", width: "100%" }} elevation={0}>
                    <PlayerLatestSessions
                        activeEnv={this.props.activeEnv}
                        playerId={this.state.playerId}
                    />
                </Paper> */}

                <Paper style={{marginTop: 20}} elevation={0}>
                    <CardHeader title="Growth fund"/>

                    <Table aria-label="simple table" style={{marginBottom: 20}}>
                        <TableBody>
                            <TableRow>
                                <TableCell component="th" scope="row">Active</TableCell>
                                <TableCell
                                    align="left">{this.state.playerData.meta?.growth_fund?.active ? "Active" : "Not active"}</TableCell>
                            </TableRow>

                            {this.state.playerData.meta?.growth_fund?.active && <TableRow>
                                <TableCell component="th" scope="row">Used</TableCell>
                                <TableCell
                                    align="left">{(this.state.playerData.meta?.growth_fund?.used || []).join(",")}</TableCell>
                            </TableRow>}
                        </TableBody>
                    </Table>
                </Paper>

                <Paper style={{marginTop: 20}} elevation={0}>
                    <CardHeader title="Recharge Deal"/>

                    <Table aria-label="simple table" style={{marginBottom: 20}}>
                        <TableBody>
                            <TableRow>
                                <TableCell component="th" scope="row">Level</TableCell>
                                <TableCell align="left" className="userTable-cell">
                                    {this.state.playerData.meta?.recharge_deal?.level}
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell component="th" scope="row">Card</TableCell>
                                <TableCell align="left" className="userTable-cell">
                                    {this.state.playerData.meta?.recharge_deal?.card}
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell component="th" scope="row">Progress</TableCell>
                                <TableCell align="left" className="userTable-cell">
                                    {this.state.playerData.meta?.recharge_deal?.gems_progress}
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell component="th" scope="row">Left Over</TableCell>
                                <TableCell align="left" className="userTable-cell">
                                    {this.state.playerData.meta?.recharge_deal?.gems_leftover}
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell component="th" scope="row">Total</TableCell>
                                <TableCell align="left" className="userTable-cell">
                                    {this.state.playerData.meta?.recharge_deal?.gems_total}
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell component="th" scope="row">
                                    <Button disableElevation onClick={this.showRechargeModal} variant="contained"
                                            size="small">
                                        Add Gems
                                    </Button>
                                </TableCell>
                                <TableCell align="left"></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>

                    {this.rechargeModal()}
                </Paper>

                <Paper style={{marginTop: 20}} elevation={0}>
                    <CardHeader title="Trader"/>

                    <Table aria-label="simple table" style={{marginBottom: 20}}>
                        <TableBody>
                            <TableRow>
                                <TableCell component="th" scope="row">Arrive At</TableCell>
                                <TableCell align="left">
                                    {this.editData({
                                        type: "date",
                                        value: this.state.playerData.meta?.trader?.arriveAt,
                                        inputType: "json",
                                        parameters: "trader.arriveAt",
                                        object: "meta"
                                    })}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">Leave At</TableCell>
                                <TableCell align="left">
                                    {this.editData({
                                        type: "date",
                                        value: this.state.playerData.meta?.trader?.leaveAt,
                                        inputType: "json",
                                        parameters: "trader.leaveAt",
                                        object: "meta"
                                    })}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Paper>

                <Paper style={{marginTop: 20}} elevation={0}>
                    <CardHeader title="Idle"/>

                    <Table aria-label="simple table" style={{marginBottom: 20}}>
                        <TableBody>
                            <TableRow>
                                <TableCell component="th" scope="row">Ignore Idle rule</TableCell>
                                <TableCell align="left">
                                    {this.editData({
                                        type: "boolean",
                                        value: this.state.playerData?.disable_idle || false,
                                        inputType: "boolean",
                                        parameters: "disable_idle",
                                        object: "root"
                                    })}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Paper>

                {this.state.playerData.meta?.active_boosters?.length > 0 &&
                    <Paper style={{marginTop: 20}} elevation={0}>
                        <CardHeader title="Boosters"/>

                        <Table aria-label="simple table" style={{marginBottom: 20}}>
                            <TableBody>
                                {this.state.playerData?.meta?.active_boosters.map((booster, index) =>
                                    <TableRow key={`${booster.id}_${index}`}>
                                        <TableCell component="th" scope="row">
                                            {GET_ITEM_NAME_BY_ID(booster.id)}
                                        </TableCell>
                                        <TableCell align="left">
                                            <DateTimePicker
                                                label="Date"
                                                value={booster.expire ? Helpers.getISOStringWithoutSecsAndMillisecs1(booster.expire) : null}
                                                onChange={date => this.onBoosterExpireEdit(index, date)}
                                                renderInput={(params) => <TextField {...params} size="small"/>}
                                                ampm={false}
                                            />
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </Paper>
                }
            </Grid>
        </Grid>
    }

    render() {
        return (
            <React.Fragment>
                <LocalizationProvider dateAdapter={AdapterDateFns}><div className="player-page--wrapper">
                    <div className="header--wrapper">
                        {this.renderPageHeader()}

                        <div className={this.props.classes.tabsRoot}>
                            <Tabs value={this.state.activeTab} onChange={this.onTabChange} style={{marginTop: 25}}>
                                <Tab style={{minWidth: 100}} value="general" label="General" {...Helpers.a11yProps("general")} />
                                <Tab style={{minWidth: 100}} value="analytics" label="Analytics" {...Helpers.a11yProps("analytics")} />
                                <Tab style={{minWidth: 100}} value="buildings" label="Buildings" {...Helpers.a11yProps("army")} />
                                <Tab style={{minWidth: 100}} value="army" label="Army" {...Helpers.a11yProps("army")} />
                                <Tab style={{minWidth: 100}} value="achievements" label="Tasks" {...Helpers.a11yProps("achievements")} />
                                <Tab style={{minWidth: 100}} value="weapons" label="Weapons" {...Helpers.a11yProps("weapons")} />
                                <Tab style={{minWidth: 100}} value="inventory" label="Inventory" {...Helpers.a11yProps("inventory")} />
                                <Tab style={{minWidth: 100}} value="processes" label="Processes" {...Helpers.a11yProps("processes")} />
                                <Tab style={{minWidth: 100}} value="purchases" label="Purchases" {...Helpers.a11yProps("purchases")} />
                                <Tab style={{minWidth: 100}} value="chat-history" label="Alliance Chat" {...Helpers.a11yProps("chat-history")} />
                                <Tab style={{minWidth: 100}} value="messages" label="Messages" {...Helpers.a11yProps("messages")} />
                                <Tab style={{minWidth: 100}} value="activity" label="Activity" {...Helpers.a11yProps("activity")} />
                                <Tab style={{minWidth: 100}} value="battle-logs" label="Battle Log" {...Helpers.a11yProps("battle-logs")} />
                                <Tab style={{minWidth: 100}} value="ruby-logs" label="Ruby Log" {...Helpers.a11yProps("ruby-logs")} />
                            </Tabs>
                            <Tabs value={this.state.activeTab} onChange={this.onTabChange} style={{marginTop: 25}}>
                                <Tab style={{minWidth: 100}} value="ruby-wager" label="Ruby Wager" {...Helpers.a11yProps("ruby-wager")} />
                                <Tab style={{minWidth: 100}} value="user-mail" label="Mails" {...Helpers.a11yProps("user-mail")} />
                                <Tab style={{minWidth: 100}} value="user-session" label="Sessions" {...Helpers.a11yProps("user-session")} />
                                <Tab style={{minWidth: 100}} value="booby-traps" label="Booby Traps" {...Helpers.a11yProps("booby-traps")} />
                            </Tabs>
                        </div>
                    </div>

                    <TabPanel  value={this.state.activeTab} index="general">
                        {this.renderGeneral()}
                    </TabPanel>
                    <TabPanel  value={this.state.activeTab} index="buildings">
                        <div className="inner-card">
                            <PlayerBuildings
                                activeEnv={this.props.activeEnv}
                                playerId={this.state.playerId}
                                playerData={this.state.playerData}
                                heroesConfig={this.state.heroesConfig}
                            />
                        </div>
                    </TabPanel>
                    <TabPanel  value={this.state.activeTab} index="army">
                        <div className="inner-card">
                            <PlayerArmy
                                activeEnv={this.props.activeEnv}
                                playerId={this.state.playerId}
                                playerData={this.state.playerData}
                                heroesConfig={this.state.heroesConfig}
                            />
                        </div>
                    </TabPanel>
                    <TabPanel  value={this.state.activeTab} index="achievements">
                        <div className="inner-card">
                            <PlayerAchievementsGroup
                                activeEnv={this.props.activeEnv}
                                playerId={this.state.playerId}
                                playerData={this.state.playerData}
                                heroesConfig={this.state.heroesConfig}
                            />
                        </div>
                    </TabPanel>
                    <TabPanel  value={this.state.activeTab} index="weapons">
                        <div className="inner-card">
                            <PlayerWeapons
                                activeEnv={this.props.activeEnv}
                                playerId={this.state.playerId}
                                playerData={this.state.playerData}
                                heroesConfig={this.state.heroesConfig}
                            />
                        </div>
                    </TabPanel>
                    <TabPanel  value={this.state.activeTab} index="inventory">
                        <div className="inner-card">
                            <PlayerInventory
                                activeEnv={this.props.activeEnv}
                                playerId={this.state.playerId}
                                playerData={this.state.playerData}
                                heroesConfig={this.state.heroesConfig}
                            />
                        </div>
                    </TabPanel>
                    <TabPanel  value={this.state.activeTab} index="processes">
                        <div className="inner-card">
                            <PlayerProcesses
                                activeEnv={this.props.activeEnv}
                                playerId={this.state.playerId}
                                playerData={this.state.playerData}
                                heroesConfig={this.state.heroesConfig}
                                {...this.props}
                            />
                        </div>
                    </TabPanel>
                    <TabPanel  value={this.state.activeTab} index="purchases">
                        <div className="inner-card">
                            <PlayerPurchases
                                activeEnv={this.props.activeEnv}
                                playerId={this.state.playerId}
                                playerData={this.state.playerData}
                                {...this.props}
                            />
                        </div>
                    </TabPanel>
                    <TabPanel  value={this.state.activeTab} index="chat-history">
                        <div className="inner-card">
                            <PlayerChatHistory
                                activeEnv={this.props.activeEnv}
                                playerId={this.state.playerId}
                                {...this.props}
                            />
                        </div>
                    </TabPanel>
                    <TabPanel  value={this.state.activeTab} index="messages">
                        <div className="inner-card">
                            <PlayerMessages
                                activeEnv={this.props.activeEnv}
                                playerId={this.state.playerId}
                                {...this.props}
                            />
                        </div>
                    </TabPanel>
                    <TabPanel  value={this.state.activeTab} index="analytics">
                        <div className="inner-card">
                            <PlayerAnalytics
                                activeEnv={this.props.activeEnv}
                                playerId={this.state.playerId}
                            />
                        </div>
                    </TabPanel>
                    <TabPanel  value={this.state.activeTab} index="activity">
                        <div className="inner-card">
                            <PlayerActivities
                                activeEnv={this.props.activeEnv}
                                playerId={this.state.playerId}
                            />
                        </div>
                    </TabPanel>

                    <TabPanel  value={this.state.activeTab} index="battle-logs">
                        <div className="inner-card">
                            <PlayerBattleLogs
                                activeEnv={this.props.activeEnv}
                                playerId={this.state.playerId}
                            />
                        </div>
                    </TabPanel>

                    <TabPanel  value={this.state.activeTab} index="ruby-logs">
                        <div className="inner-card">
                            <PlayerRubyLogs
                                activeEnv={this.props.activeEnv}
                                playerId={this.state.playerId}
                            />
                        </div>
                    </TabPanel>

                    <TabPanel  value={this.state.activeTab} index="ruby-wager">
                        <div className="inner-card">
                            <PlayerRubyWager
                                activeEnv={this.props.activeEnv}
                                playerId={this.state.playerId}
                            />
                        </div>
                    </TabPanel>

                    <TabPanel  value={this.state.activeTab} index="user-mail">
                        <div className="inner-card">
                            <PlayerMail
                                activeEnv={this.props.activeEnv}
                                playerId={this.state.playerId}
                            />
                        </div>
                    </TabPanel>

                    <TabPanel  value={this.state.activeTab} index="user-session">
                        <div className="inner-card">
                            <PlayerSession
                                activeEnv={this.props.activeEnv}
                                playerId={this.state.playerId}
                            />
                        </div>
                    </TabPanel>
                    <TabPanel  value={this.state.activeTab} index="booby-traps">
                        <div className="inner-card">
                            <PlayerBoobyTraps
                                activeEnv={this.props.activeEnv}
                                playerId={this.state.playerId}
                            />
                        </div>
                    </TabPanel>
                </div></LocalizationProvider>
            </React.Fragment>
        );
    }
}

const styles: any = theme => ({
    paper: {
        padding: 16,
    },
    banned: {
        paddingTop: 16,
        color: theme.palette.error.main,
    },
    tabsRoot: {
        borderBottom: "1px solid #d8d8d8",
    }
});

export const Player = withStyles(styles)(PlayerWrapped);
